import { Title } from "../../Atoms/Title";
import { FormClientRegister } from "../../Molecules/FormClientRegister";
import * as S from "./styles";
import { useClientRegister } from "./useClientRegister";

export const ClientRegisterTemplate = () => {
  const { handleForm } = useClientRegister();

  return (
    <S.Container>
      <S.Wrapper>
        <Title>Cadastro de Clientes</Title>
        <FormClientRegister submitForm={handleForm} />
      </S.Wrapper>
    </S.Container>
  );
};
